import React from "react";
import { motion } from "framer-motion";
import styles from "./TestimonialsComponent.module.css";

const testimonials = [
  {
    name: "",
    role: "Owner, Gueros's Barbershop",
    testimonial:
      "Daniel built a sleek, user-friendly website for my barbershop that displays all our services, hours, and locations. He also created a menu page with QR codes, so customers can easily access our services right from their phones while they're in the shop. It’s been a game-changer for us!",
    companyLogo: "/barberlogo.jpg",
    url: "https://www.guerosbarbershop.com/",
  },
  {
    name: "",
    role: "Owner, Saguaro Pallets",
    testimonial:
      "Daniel developed a custom website and mini CRM for our pallet company. It not only showcases our services but also helps us manage sales and repair requests seamlessly. Thanks to his work, we've improved our sales process and communication with clients. Highly recommend him!",
    companyLogo: "/saglogo.png",
    url: "https://www.saguaropallets.com/",
  },
  {
    name: "",
    role: "Owner, JG Paint",
    testimonial:
      "Daniel’s expertise was crucial in developing a professional, functional website for my paint contracting business. It’s easy to navigate, reflects our brand, and makes it easier for customers to get in touch. His attention to detail and commitment to meeting our needs really stood out.",
    companyLogo: "/paintlogo.jpg",
    url: "https://www.paintjg.com/",
  },
  
];

const TestimonialsComponent = () => {
  return (
    <section className={styles.testimonials}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h2 className={styles.sectionTitle}>Testimonials</h2>
        <p className={styles.sectionSubtitle}>
          Here’s how our solutions have helped businesses like yours thrive.
        </p>
        
        <motion.div 
          className={styles.testimonialsGrid}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ staggerChildren: 0.3 }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className={styles.testimonialCard}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <a href={testimonial.url} target="_blank">
                <img
                  src={testimonial.companyLogo}
                  alt={`${testimonial.name}'s company logo`}
                  className={styles.companyLogo}
                />
              </a>
              <p className={styles.testimonialText}>
                “{testimonial.testimonial}”
              </p>
              <p className={styles.clientName}>
                <strong>{testimonial.name}</strong> - {testimonial.role}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default TestimonialsComponent;
